module.exports = __webpack_public_path__ + "img/29_1.447b0f5c.png";